// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconCloche = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M14 6q0 .09-.008.18c4.15.76 7.46 3.847 7.946 7.807H23v2h-1.408L19.335 20H4.665l-2.257-4.013H1v-2h1.062c.486-3.96 3.796-7.047 7.946-7.807A2 2 0 1114 6m-9.297 9.987L5.835 18h12.33l1.132-2.013zm-.618-2C4.64 10.677 7.88 8 12 8s7.36 2.678 7.915 5.987z"
    />
  );
export default SvgIconCloche;
